'use client'
import useFlightTimingFilterManager from '@/src/hooks/srp/flightTimingFilterManager'
import { FlightTimingsFilter } from '../flightTimings/FlightTimingsFilter'
import { useMulticitySectionJourneyIndex } from '../multicityFilterJourneyScope'

const ArrivalTimingsFilterWrapper = () => {
    const filterJourneyIndex = useMulticitySectionJourneyIndex(0)
    const { timeSlots, handleSelectToggle, handleReset, handleResetAllJourneys, shouldShowReset, shouldShowResetForAllJourneys, isMulticity, title, hideBottomDivider } = useFlightTimingFilterManager(
        filterJourneyIndex,
        'arrival'
    )

    return (
        <FlightTimingsFilter
            flightTimings={timeSlots}
            onTimeSlotSelect={handleSelectToggle}
            onReset={isMulticity ? handleResetAllJourneys : handleReset}
            shouldShowReset={isMulticity ? shouldShowResetForAllJourneys : shouldShowReset}
            title={title}
            hideBottomDivider={hideBottomDivider}
        />
    )
}

export { ArrivalTimingsFilterWrapper as ArrivalTimingsFilter }

export default ArrivalTimingsFilterWrapper
